import clsx from 'clsx';
import { LogType } from '../types/visualizer';

import { Button } from '@@/ui/primitives';
import { GitBranchIcon, LogsIcon } from 'lucide-react';

export function ViewNavigation(props: {
  allowedLogTypes: LogType[];
  selectedLogType: LogType;
  onLogTypeChange: (logType: LogType) => void;
  disabled: boolean;
}) {
  return (
    <div className='flex items-center gap-1'>
      <span className='text-xs! font-semibold! text-muted-foreground px-2'>View</span>
      <div className='flex items-center gap-2'>
        {props.allowedLogTypes.map((logType) => {
          const selected = props.selectedLogType === logType;

          return (
            <Button
              key={logType}
              size='xs'
              variant='ghost'
              className={clsx(
                'font-medium! px-2! rounded-sm',
                'gap-2',
                // 'hover:bg-transparent',
                // 'flex items-center gap-2 px-2 rounded-md py-0.5',
                selected ? 'bg-slate-200!' : '',
                selected ? 'text-slate-950!' : 'text-muted-foreground'
              )}
              onClick={() => props.onLogTypeChange(logType)}
            >
              {logType === LogType.INTERACTION_LOG ? (
                <GitBranchIcon className='size-4' />
              ) : (
                <LogsIcon className='size-4' />
              )}
              {logType === LogType.INTERACTION_LOG ? 'Interaction' : 'Flow'}
            </Button>
          );
        })}
      </div>
    </div>
  );
}
